import { memo } from 'react';
import {
  setComma,
  classNameBind,
} from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import * as S from './style';

interface IProps {
  text?: string;
  cnt?: number;
  active?: boolean;
  color?: string;
  colorUrl?: string;
  onClick?: () => void;
}

const FltColorItem = ({
  text,
  cnt,
  active,
  color,
  colorUrl,
  onClick,
}: IProps) => {
  const cName = classNameBind(['filter-color item', active ? 'active' : '']);

  return (
    <S.FltColorItem className={cName}>
      <Button onClick={onClick}>
        <S.Color className="color" color={color || ''}>
          {colorUrl ? (
            <Img src={colorUrl} alt={text} />
          ) : (
            <span className="bg-color" />
          )}
        </S.Color>
        <Text className="name">{text}</Text>
        {cnt != null && <Text className="cnt">{setComma(String(cnt))}</Text>}
      </Button>
    </S.FltColorItem>
  );
};

export default memo(FltColorItem);
